<script lang="ts">
  import { removeToast, toastComponent } from "./toast-store";
</script>

<div class:top-[-64px]={$toastComponent.hidden} class="fixed top-8 right-8 transition-top ease-in-out duration-[295ms] flex gap-[12px] 
justify-center items-center p-4 z-50 text-green bg-green-light rounded-[12px] z-[1999] max-w-[calc(100vw-64px)]">
  <ion-icon name="checkmark-circle-outline" class="text-md text-green" ></ion-icon>
  { $toastComponent.label }
  <svg on:click={removeToast} xmlns="http://www.w3.org/2000/svg" class="w-6 cursor-pointer" viewBox="0 0 512 512">
    <title>Close</title>
    <path
      fill="none"
      stroke="#757575"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M368 368L144 144M368 144L144 368"
    />
  </svg>
</div>